import { render } from "./ImprimirPedidos.vue?vue&type=template&id=92000300&scoped=true"
import script from "./ImprimirPedidos.vue?vue&type=script&lang=js"
export * from "./ImprimirPedidos.vue?vue&type=script&lang=js"

import "./ImprimirPedidos.vue?vue&type=style&index=0&id=92000300&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92000300"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput});
